import { FC } from 'react';
import { BsThreeDots } from 'react-icons/bs';
import { Button, Dropdown, MenuProps } from 'antd';
import { useTranslation } from 'react-i18next';
import { IRequest } from '../../../interfaces/requests.interface';

interface IActionsProps {
	record: IRequest;
	setAssignDriver: (value: IRequest | null) => void;
	setViewSearch: (value: IRequest | null) => void;
}

const Actions: FC<IActionsProps> = ({ record, setAssignDriver, setViewSearch }) => {
    const { t } = useTranslation('small-fleet-orders');

    const items: MenuProps['items'] = [
        {
            key: 'view-search',
            label: t('VIEW_SEARCH'),
            onClick: () => setViewSearch(record),
        },
        {
            key: 'assign-driver',
            label: t('ASSIGN_DRIVER'),
            onClick: () => setAssignDriver(record),
        },
    ];

    return (
        <Dropdown
            menu={{ items }}
            trigger={['click']}
        >
            <Button
                icon={<BsThreeDots size={16} />}
                type="link"
            />
        </Dropdown>
    );
};

export { Actions };
